export default [
    {
        path: '/schedule-new',
        name: 'schedule',
        component: () => import ('../schedule/views/Index.vue'),
        meta: {
            title: 'Horário das aulas',
            icon: 'mdi-timeline-clock-outline',
            breadcrumbs: [
                { text: 'Horário', disabled: true, href: '/' },
                { text: 'Horário das aulas', disabled: true, href: '/' },
            ],
        }
    }
]
